import React, { useState } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide toggle. Drop-in replacement for
 * `<Input type="password" ... />`.
 *
 * All props (id, value, onChange, placeholder, required, className, data-testid)
 * are forwarded to the underlying Input.
 */
export default function PasswordInput({ className = "", dataTestId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        data-testid={dataTestId}
        type={show ? "text" : "password"}
        className={`pr-11 ${className}`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={dataTestId ? `${dataTestId}-toggle` : undefined}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute inset-y-0 right-0 flex items-center justify-center w-11 text-[var(--mp-muted)] hover:text-[var(--mp-ink)] transition-colors"
        tabIndex={-1}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
